export default __webpack_public_path__ + "static/media/advanced.604273ce.png";